import { useParams, useLocation, useNavigate } from "react-router-dom";
import DebtDetailContent from "../components/transfers/DebtDetailContent";
import PageDocumentation from "../components/PageDocumentation";

function DebtDetail() {
  const navigate = useNavigate();
  const { userId, transferId } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type");
  const extraInfo = queryParams.get("extraInfo");

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-xl font-semibold">Detalle de Deuda</h1>
        <PageDocumentation docKey="debt-detail" />
      </div>
      <DebtDetailContent
        userId={userId}
        type={type}
        extraInfo={extraInfo}
        transferId={transferId}
        onSuccess={() => navigate("/transfers/debts")}
        onCancel={() => navigate(-1)}
        isModal={false}
      />
    </div>
  );
}

export default DebtDetail;
